<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Add handler
      </h3>

      <validation-observer ref="handler-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="airport_id"
              v-slot="{ errors }">
              <label for="id">Airport:</label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="airports"
                  v-model="data.airport_id"
                  :reduce="airport => airport.id"
                  :filterBy="filterByAirports"
                  placeholder="Select an airport"
                  :maxItemsDisplay="100"
                  label="id">
                  <template slot="no-options">
                    There are no airports for the provided phrase&hellip;
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.icao }} ({{ option.name }})
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.icao }} ({{ option.name }})
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group w-100">
            <label for="name">Name:</label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group w-100">
            <label for="name">Phone:</label>

            <validation-provider
              rules="required"
              name="phone"
              v-slot="{ errors }">
              <d-input
                v-model="data.phone"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group w-100">
            <label for="name">E-mail:</label>

            <validation-provider
              rules="email"
              name="email"
              v-slot="{ errors }">
              <d-input
                v-model="data.email"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group w-100">
            <label for="name">Handler frequency:</label>

            <validation-provider
              rules="required"
              name="handler_frequency"
              v-slot="{ errors }">
              <d-input
                v-model="data.handler_frequency"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group w-100">
            <label for="notes">Type:</label>

            <div class="mt-1">
              <d-form-radio
                inline
                name="type"
                v-model="data.type"
                value="AGENT">
                Agent
              </d-form-radio>
              <d-form-radio
                inline
                name="type"
                v-model="data.type"
                value="HANDLER">
                Handler
              </d-form-radio>

              <span class="ml-5">
                <d-checkbox
                  inline
                  v-model="data.fbo"
                  toggle>
                  FBO
                </d-checkbox>
              </span>
            </div>
          </div>

          <div class="form-group w-100">
            <label for="email">Website:</label>

            <d-input-group>
              <d-input
                v-model="data.website" />
              <d-input-group-addon append>
                <d-btn
                  theme="primary"
                  :disabled="!data.website"
                  @click.prevent="openUrl(data.website)">
                  <i class="material-icons">launch</i>
                </d-btn>
              </d-input-group-addon>
            </d-input-group>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';
import HasUrlField from './../../mixins/HasUrlField.vue';
import Vue from 'vue';

export default {
  name: 'AirportHandlerPopup',
  mixins: [
    HasUrlField
  ],
  data () {
    return {
      isVisible: false,
      airports: [],
      loading: false,
      data: {
        id: null,
        name: '',
        phone: '',
        email: '',
        handler_frequency: '',
        fbo: false,
        type: 'HANDLER',
        website: '',
        airport_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-airport-handler-popup', this.show);
  },
  methods: {
    show (airportsData) {
      this.loading = false;
      this.airports = airportsData;

      this.data = {
        id: null,
        name: '',
        phone: '',
        email: '',
        handler_frequency: '',
        type: 'HANDLER',
        airport_id: this.airports.length === 1 ? this.airports[0].id : null
      };

      Vue.nextTick(() => {
        this.$refs['handler-form'].reset();
        this.isVisible = true;
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['handler-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/handlers/store',
        formData: this.data,
        successTitle: 'Handler added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the handler. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('handlers-list-reload');
          this.$bus.$emit('airports-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    filterByAirports (option, label, search) {
      return (option.name + ' ' + option.icao).toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-handler-popup', this.show);
  }
}
</script>
